exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".collapsible-toggle>.svg-inline--fa{margin-right:10px}.collapsible-item>ul{margin-top:5px}.noicon{padding-left:33px}\n", ""]);
